"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSignupState = void 0;
exports.defaultSignupState = {
    isActive: false,
    isDim: false,
    isLoading: false,
    signupFields: {
        email: '',
    },
    t: {
        nameTitle: 'Continue with Email',
        nameCaption: 'Be the first to know about new homes and price changes',
        nameOr: 'or',
        nameFacebook: 'Continue with Facebook',
        nameHaveAccount: 'Already have an account',
        nameLogin: 'Login',
        nameCancel: 'Cancel',
    },
    tForm: {
        email: 'Email',
        submit: 'Continue',
        required: 'Required',
        emailFormat: 'Invalid Email Format',
    },
};
